import { useEffect, useState } from "react";
import { forgotPassword } from "../service/auth_service";

const ForgotPasswordModal = ({ show, onClose }) => {
  const [activeView, setActiveView] = useState("form");
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  // form | reset | pendingInvite | inactive | pendingLogin

  useEffect(() => {
    if (show) {
      setActiveView("form");
      setEmail("");
      setErrorMessage("");
      setSubmitting(false);
    }
  }, [show]);

  const handleSubmit = async () => {
    const normalizedEmail = email.trim();
    if (!normalizedEmail) {
      setErrorMessage("* Email is required");
      return;
    }

    setSubmitting(true);
    setErrorMessage("");

    try {
      const response = await forgotPassword(normalizedEmail);
      const result = response?.data || {};
      const status = String(result?.status ?? result?.Status ?? "").toUpperCase();

      if (status === "NOT_FOUND") {
        setErrorMessage(result?.message || "Please enter registered email");
        return;
      }
      if (status === "PENDING_INVITE") {
        setActiveView("pendingInvite");
        return;
      }
      if (status === "INACTIVE") {
        setActiveView("inactive");
        return;
      }
      if (status === "PENDING_LOGIN") {
        setActiveView("pendingLogin");
        return;
      }
      if (status === "SUCCESS") {
        setActiveView("reset");
      } else {
        setErrorMessage(result?.message || "Failure sending email");
      }
    } catch {
      setErrorMessage("Some exception occurred. Please contact admin");
    } finally {
      setSubmitting(false);
    }
  };

  if (!show) return null;

  return (
    <>
    <div className="modal fade in" style={{ display: "block" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">

          {/* Modal Header */}
          <div className="modal-header pb-0">
            <button
              type="button"
              className="close"
              onClick={onClose}
            >
              &times;
            </button>
            <h4 className="modal-title">Temporary password</h4>
          </div>

          {/* Modal Body */}
          <div className="modal-body">

            {/* Success Reset */}
            {activeView === "reset" && (
              <div>
                <div className="row">
                  <div className="col-sm-12">
                    <p>
                      An email has been sent to you with a link to reset your
                      password. If you haven't received an email, please contact
                      investor services for further assistance.
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <a href="/" style={{ color: "#007bff" }}>
                      Back to Login Page
                    </a>
                  </div>
                </div>
              </div>
            )}

            {/* Pending Login */}
            {activeView === "pendingLogin" && (
              <div>
                <div className="row">
                  <div className="col-sm-12">
                    <p>
                      Beatrice Advisors sent you an email containing
                      instructions on how to login to the new website.
                      If you cannot find the email please contact{" "}
                      <a
                        href="mailto:clientservices@beatriceadvisors.com"
                        style={{ textDecorationLine: "none" }}
                      >
                        <span style={{ color: "#239099" }}>
                          Client Services
                        </span>
                      </a>{" "}
                      for assistance.
                    </p>
                  </div>
                </div>
              </div>
            )}

            {activeView === "pendingInvite" && (
              <div>
                <div className="row">
                  <div className="col-sm-12">
                    <p>
                      Your account invitation is pending. Please contact client services for assistance.
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <a href="/" style={{ color: "#007bff" }}>
                      Back to Login Page
                    </a>
                  </div>
                </div>
              </div>
            )}

            {activeView === "inactive" && (
              <div>
                <div className="row">
                  <div className="col-sm-12">
                    <p>
                      Your account is inactive. Please contact client services for assistance.
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <a href="/" style={{ color: "#007bff" }}>
                      Back to Login Page
                    </a>
                  </div>
                </div>
              </div>
            )}

            {/* Default Form */}
            {activeView === "form" && (
              <>
                <div className="row">
                  <div className="col-sm-12">
                    <p
                      style={{
                        textAlign: "justify",
                        color: "black",
                        fontSize: "17px",
                      }}
                    >
                      To receive an email with a temporary password, Please
                      enter your Login ID and click Go to complete your password
                      reset request.
                    </p>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-8">
                    <input
                      style={{
                        border: "1px solid black",
                        width: "300px",
                        padding: "7px",
                      }}
                      type="text"
                      placeholder="Email address"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setErrorMessage("");
                      }}
                      onKeyUp={(e) => {
                        if (e.key === "Enter") {
                          handleSubmit();
                        }
                      }}
                    />
                  </div>

                  <div
                    className="col-sm-2"
                    style={{ position: "relative", right: "15px" }}
                  >
                    <button
                      type="button"
                      className="btn1 btn-primary"
                      onClick={handleSubmit}
                      disabled={submitting}
                    >
                      {submitting ? "Please wait..." : "Go"}
                    </button>
                  </div>
                </div>
                {errorMessage ? (
                  <div className="row" style={{ marginTop: "8px" }}>
                    <div className="col-sm-12">
                      <p style={{ color: "red", fontSize: "15px" }}>{errorMessage}</p>
                    </div>
                  </div>
                ) : null}
              </>
            )}

          </div>
        </div>
      </div>
    </div>
    {/* Backdrop */}
    {/* <div
        className="modal-backdrop fade in"
        onClick={onClose}
    /> */}
    </>
  );
};

export default ForgotPasswordModal;
